import {
  createBrowserRouter,
} from "react-router-dom";
import { SignIn } from "./pages/SignIn";
import { RegisterStep1 } from "./pages/RegisterStep1";
import { RegisterStep2 } from "./pages/RegisterStep2";
import { RegisterStep3 } from "./pages/RegisterStep3";
import { YourAccount } from "./pages/YourAccount";
import { Activate } from "./pages/Activate";
import { ResetPasswordStep2 } from "./pages/ResetPasswordStep2";
import { ResetPasswordStep1 } from "./pages/ResetPasswordStep1";

const controller = "/app";

export const Routes = 
  createBrowserRouter([
  {
    path: "/",
    element: <SignIn></SignIn>,
  },
  {
    path: "/Register",
    element: <RegisterStep1></RegisterStep1>,
  },
  {
    path: "/Register/Step2",
    element: <RegisterStep2></RegisterStep2>,
  },
  {
    path: "/Register/Step3",
    element: <RegisterStep3></RegisterStep3>,
  },
  {
    path: "/YourAccount",
    element:  <YourAccount></YourAccount>
  },
  {
    path: "/Activate",
    element: <Activate></Activate>,
  },
  {
    path: "/ResetPasswordStep1",
    element: <ResetPasswordStep1></ResetPasswordStep1>,
  },
  {
    path: "/ResetPasswordStep2",
    element: <ResetPasswordStep2></ResetPasswordStep2>,
  },

],{basename: controller});